export default "__VITE_ASSET__ba979fd6__"